import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Console } from 'console';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';


@Component({
  selector: 'app-exam-edid-dialog-box',
  templateUrl: './exam-edid-dialog-box.component.html',
  styleUrls: ['./exam-edid-dialog-box.component.scss']
})

export class ExamEdidDialogBoxComponent implements OnInit {
  submitButton = true;
  updateButton = false;
  showDiv = false;
  deleteReadOnly = false;
  Table = false;
  ExamSCEditForm: FormGroup;
  elgbRuleList;
  filteredElgbRuleList;
  filteredExamAList;
  dialogRef: MatDialogRef<any>;
  // empty after assignig to api start
  ExamAList;
  examRecords;
  // empty after assignig to api end
  statusList = [
    {
      name: 'Open',
      id: 'O',
    },
    {
      name: 'Close',
      id: 'C',
    },
  ];
  filteredListOfEmEval: any;
  ExamInputList: any;
  filteredExamInputList: any;
  filteredstatusList: any;
  userList: any;
  filtereduserList: any;
  Glob_EcShId: any;
  APIService: string;
  userPermission: any;
  utp: any;
  ExCreate = true;
  ExUpdate = true;
  ExDelete = true;
  loginId = sessionStorage.getItem('userId');
  SessionNo: any;
  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private fb: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if(JSON.parse(sessionStorage.getItem("session")) == null){
      this.fetchSecretData();
    }
    else if(JSON.parse(sessionStorage.getItem("session")) != null){
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo;
      this.fetchSupExamRecord(this.SessionNo);
    }
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Exam-Edit-Schedule' && element.PCreate == false) {
          this.ExCreate = false;
        }
        if (element.PageName == 'Exam-Edit-Schedule' && element.PUpdate == false) {
          this.ExUpdate = false;
        }
        if (element.PageName == 'Exam-Edit-Schedule' && element.PDelete == false) {
          this.ExDelete = false;
        }
      });
    }
    window.scroll(0, 0);
    this.fetchSupExamInputs();
    this.getOpratorsList();
    this.Table = false;
    this.filteredstatusList = this.statusList.slice();
    // empty after assignig to api start
    this.ExamSCEditForm = this.fb.group({
      EcShId: new FormControl('', Validators.required),
      EcDesc: new FormControl('New'),
      EcInCode: new FormControl('', Validators.required),
      EcOpId: new FormControl('', Validators.required),
      EcOpenOpId: new FormControl(sessionStorage.getItem('userId')),
      EcStatus: new FormControl('O'),
      FrontEcInCode: new FormControl(''),
      FrontList: new FormControl(''),
      EcListNo: new FormControl(''),
      EcId: new FormControl(''),
    });
    // empty after assignig to api end
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      this.fetchSupExamRecord(this.SessionNo);
      }
    );
  }

  submit() {
    if (this.ExamSCEditForm.valid) {
      this.spinner.show();
      this.umsService.submitSupExam(this.ExamSCEditForm.value).subscribe(
        (res) => {
          this.spinner.hide();
          this.loadExamRecords();
          if (res.status) {
            let data = {};
            data['message'] = res.message;
            data['title'] = 'Information';
            data['icon'] = 'fas fa-check';
            this.dialogRef =
              this.modalPopupService.openPopup<AlertBoxComponent>(
                AlertBoxComponent,
                data
              );
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
    } else {
      this.ExamSCEditForm.get('EcShId').markAsTouched();
      this.ExamSCEditForm.get('EcInCode').markAsTouched();
      this.ExamSCEditForm.get('EcOpId').markAsTouched();
    }
  }

  update() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.ExamSCEditForm.value['EcId'];
    payload['InCode'] = this.ExamSCEditForm.value['EcInCode'];
    this.umsService.ValidateSCHExamInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.message == '') {
          let data = {};
          data['message'] =
            'Database will be updated. Database Tags will be removed and the list will be marked Updated' +
            ', Proceed?';
          data['title'] = 'Process Result';
          data['icon'] = 'fa fa-question';
          this.dialogRef =
            this.modalPopupService.openPopup<ConformationModelComponent>(
              ConformationModelComponent,
              data
            );
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result === 'yes') {
              this.updateInput(payload);
              this.ngOnInit();
              this.showDiv = false;
              return true;
            } else {
              let gstrVldtMesg = 'Processing Cancelled';
              let data = {};
              data['message'] = gstrVldtMesg;
              data['title'] = 'Information';
              data['icon'] = 'fas fa-close';
              this.dialogRef =
                this.modalPopupService.openPopup<AlertBoxComponent>(
                  AlertBoxComponent,
                  data
                );
              this.ngOnInit();
              this.showDiv = false;
              return false;
            }
          });
        } else {
          let gstrVldtMesg = res.message;
          let data = {};
          data['message'] = gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          return false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        // alert(ERROR);
        this.ngOnInit();
        this.showDiv = false;
      }
    );
  }

  updateInput(e) {
    this.spinner.show();
    let payload = {};
    (payload['LoginId'] = sessionStorage.getItem('userId')),
      (payload['EcId'] = e.EcId),
      (payload['InCode'] = e.InCode),
      (payload['Inst'] = parseInt(sessionStorage.getItem('Inst')));
    this.umsService.UpdateSCHExamInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (payload['InCode'] == 20) {
          this.centerAllocationApi(payload);
        } else {
          let gstrVldtMesg = res.message;
          let data = {};
          data['message'] = gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-check';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          this.loadExamRecords();
          this.ngOnInit();
          this.showDiv = false;
          return false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ngOnInit();
        this.showDiv = false;
        // alert(ERROR);
      }
    );
  }

  centerAllocationApi(e) {
    this.spinner.show();
    let payload = {};
    (payload['LoginId'] = sessionStorage.getItem('userId')),
      (payload['EcId'] = e.EcId),
      (payload['RollNo'] = ''),
      (payload['Inst'] = parseInt(sessionStorage.getItem('Inst')));
    this.umsService.UpdateSCHExamCenterAllocationInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        let gstrVldtMesg = res.message;
        this.loadExamRecords();
        let data = {};
        data['message'] = gstrVldtMesg;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.ngOnInit();
        this.showDiv = false;
        return false;
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ngOnInit();
        this.showDiv = false;
        // alert(ERROR);
      }
    );
  }

  Delete() {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        EcShId: this.ExamSCEditForm.value['EcShId'],
        EcDesc: this.ExamSCEditForm.value['EcDesc'],
        EcInCode: this.ExamSCEditForm.value['EcInCode'],
        EcOpId: this.ExamSCEditForm.value['EcOpId'],
        EcOpenOpId: this.ExamSCEditForm.value['EcOpenOpId'],
        EcStatus: this.ExamSCEditForm.value['EcStatus'],
        FrontEcInCode: this.ExamSCEditForm.value['FrontEcInCode'],
        FrontList: this.ExamSCEditForm.value['FrontList'],
        EcListNo: this.ExamSCEditForm.value['EcListNo'],
        EcId: this.ExamSCEditForm.value['EcId']
      },
    };

    this.httpClient.delete(this.APIService + '/supervisor/examControl', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
          this.showDiv = false;
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        this.showDiv = false;
      });
  }

  fetchSupExamRecord(SnNo) {
    this.spinner.show();
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = SnNo;
    this.umsService.getSupExamRecord(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.ExamAList = res.data;
        this.filteredExamAList = this.ExamAList.slice();
      } else {
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamAList = this.ExamAList.slice();
      }
    );
  }

  fetchSupExamInputs() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSupExamInputs(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.ExamInputList = res.data;
          this.filteredExamInputList = this.ExamInputList.slice();
        } else {
          this.ExamAList = [];
          this.filteredExamInputList = this.ExamInputList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filteredExamInputList = this.ExamInputList.slice();
      }
    );
  }

  getOpratorsList() {
    this.spinner.show();
    let payload = {};
    this.umsService.getUserList(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.userList = res.data;
          this.filtereduserList = this.userList.slice();
        } else {
          this.userList = [];
          this.filtereduserList = this.userList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.ExamAList = [];
        this.filtereduserList = this.userList.slice();
      }
    );
  }

  loadExamRecords() {
    this.spinner.show();
    this.Glob_EcShId = this.ExamSCEditForm.value['EcShId'];
    let payload = {};
    payload['EcShId'] = this.ExamSCEditForm.value['EcShId'];
    payload['EcInCode'] = this.ExamSCEditForm.value['FrontEcInCode'];
    payload['EcOpId'] = sessionStorage.getItem('userId');
    this.umsService.getSupExamEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.Table = true
          this.examRecords = res.data;
        } else {
          this.Table = false;
          this.examRecords = [];
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.Table = false;
        this.spinner.hide();
        this.examRecords = [];
      }
    );

  }

  prepopulate(exam) {
    this.submitButton = false;
    this.showDiv = true;
    let abc = exam.InDesc;
    if (exam.EcStatus == 'O') {
      this.updateButton = true;
    } else {
      this.updateButton = false;
    }
    this.ExamSCEditForm = this.fb.group({
      EcShId: new FormControl(this.Glob_EcShId),
      EcDesc: new FormControl(exam.EcDesc),
      EcInCode: new FormControl(exam.EcInCode),
      EcOpId: new FormControl(exam.LoginIdL1),
      EcOpenOpId: new FormControl(sessionStorage.getItem('userId')),
      EcStatus: new FormControl(exam.EcStatus),
      FrontEcInCode: new FormControl(''),
      FrontList: new FormControl(''),
      EcListNo: new FormControl(exam.EcListNo),
      EcId: new FormControl(exam.EcId),
    });
  }

  addNew() {
    let tempEcShId = this.ExamSCEditForm.value['EcShId'];
    let temp = this.ExamSCEditForm.value['FrontEcInCode'];
    if (this.ExamSCEditForm.controls['EcShId'].valid) {
      this.submitButton = true;
      this.showDiv = true;
      this.updateButton = false;
      this.ExamSCEditForm.reset();
      this.ExamSCEditForm.controls['FrontEcInCode'].setValue(temp);
      this.ExamSCEditForm.controls['EcShId'].setValue(tempEcShId);
      this.ExamSCEditForm.controls['EcDesc'].setValue('New');
      this.ExamSCEditForm.controls['EcOpId'].setValue(parseInt(this.loginId));
      this.ExamSCEditForm.controls['EcOpenOpId'].setValue(parseInt(this.loginId));
      this.ExamSCEditForm.controls['EcStatus'].setValue('O');
    } else {
      this.ExamSCEditForm.get('EcShId').markAsTouched();
    }
  }

  reset(exm) {
    this.ExamSCEditForm.reset();
    this.showDiv = false;
    this.ExamSCEditForm.controls['EcShId'].setValue(exm);
    this.ExamSCEditForm.controls['EcDesc'].setValue('New');
    this.ExamSCEditForm.controls['EcOpId'].setValue(parseInt(this.loginId));
    this.ExamSCEditForm.controls['EcOpenOpId'].setValue(parseInt(this.loginId));
    this.ExamSCEditForm.controls['EcStatus'].setValue('O');
  }
}
